/**
 * Utility functions for handling scroll behavior
 */

/**
 * Reset scroll position to top for all scrollable elements
 * This is a brute force approach that targets multiple elements
 */
export function resetScrollPositions() {
    // First, reset window scroll
    window.scrollTo(0, 0);

    // Try common container class names
    const scrollableSelectors = [
        '.content-container',
        '.overflow-y-auto',
        '.overscroll-contain',
        '.mobile-scroll-container',
        '[class*="overflow-y"]' // Target any class containing overflow-y
    ];

    // Query and reset all potential scrollable elements
    const scrollableElements = document.querySelectorAll(scrollableSelectors.join(', '));
    scrollableElements.forEach(el => {
        try {
            (el as HTMLElement).scrollTop = 0;
        } catch (e) {
            // Ignore errors if element isn't scrollable
        }
    });

    // Also try to find specific container by ID
    const contentContainer = document.getElementById('discover-content-container');
    if (contentContainer) {
        contentContainer.scrollTop = 0;
    }

    // Force scroll to top for the document body as well
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}
